import { UserReportFilterDto } from './userReportTypes';

export class UserReportClient {
  private readonly baseUrl: string;

  constructor(baseUrl: string = '/api/reports/run/userreport') {
    this.baseUrl = baseUrl;
  }

  private async getHeaders(): Promise<HeadersInit> {
    const token = await window.Clerk?.session?.getToken?.({ template: 'Orderly_default' });
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async runUserReport(filter: UserReportFilterDto): Promise<void> {
    const headers = await this.getHeaders();
    const response = await fetch(this.baseUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(filter),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Failed to queue user report' }));
      throw new Error(errorData.message || 'Failed to queue user report');
    }
  }
}

let _client: UserReportClient | null = null;

export const getUserReportClient = (): UserReportClient => {
  if (!_client) _client = new UserReportClient();
  return _client;
};

export * from './userReportTypes';
